import { useApi } from '@hero/context';
import type { UseCurrentUserCashbackApi } from './types';
import { useQueryAPI } from '../../utils';

/**
 * Get current user cashback summary.
 * Returns advance payment cashback eligibility, active invoice cashback count, total potential savings.
 *
 * **Customer-only** — uses `useApi('customer')`. Only call from components
 * that render exclusively in customer context.
 *
 * Hook API: {@link UseCurrentUserCashbackApi}
 */
export const useCurrentUserCashbackApi: UseCurrentUserCashbackApi = apiConfig => {
  const api = useApi('customer');
  return useQueryAPI({
    entity: 'cashback',
    apiFn: api.cashback.getCurrentUser,
    query: undefined,
    apiConfig,
  });
};
